<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/alsobyjoannastephenward"><span class="item-title-text">Also By Joanna Stephen -Ward</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-group toc-item-element-type-part has-no-leading-number has-no-author has-children">
<p class="item-title"><a href="#/part001"><span class="item-title-text">Part I</span></a></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part001chapter001"><span class="item-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part001chapter002"><span class="item-title-text">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part001chapter003"><span class="item-title-text">Chapter 3</span></a></p>
</div>
</div>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter4"><span class="item-title-text">Chapter 4</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter5"><span class="item-title-text">Chapter 5</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter6"><span class="item-title-text">Chapter 6</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter7"><span class="item-title-text">Chapter 7</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter8"><span class="item-title-text">Chapter 8</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter9"><span class="item-title-text">Chapter 9</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter10"><span class="item-title-text">Chapter 10</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter11"><span class="item-title-text">Chapter 11</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter12"><span class="item-title-text">Chapter 12</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter13"><span class="item-title-text">Chapter 13</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter14"><span class="item-title-text">Chapter 14</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter15"><span class="item-title-text">Chapter 15</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter16"><span class="item-title-text">Chapter 16</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter17"><span class="item-title-text">Chapter 17</span></a></p>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-group toc-item-element-type-part has-no-leading-number has-no-author has-children">
<p class="item-title"><a href="#/part002"><span class="item-title-text">Part II</span></a></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter18"><span class="item-title-text">Chapter 18</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter19"><span class="item-title-text">Chapter 19</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter20"><span class="item-title-text">Chapter 20</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter21"><span class="item-title-text">Chapter 21</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter22"><span class="item-title-text">Chapter 22</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter23"><span class="item-title-text">Chapter 23</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter24"><span class="item-title-text">Chapter 24</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter25"><span class="item-title-text">Chapter 25</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter26"><span class="item-title-text">Chapter 26</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter27"><span class="item-title-text">Chapter 27</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter28"><span class="item-title-text">Chapter 28</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter29"><span class="item-title-text">Chapter 29</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter30"><span class="item-title-text">Chapter 30</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter31"><span class="item-title-text">Chapter 31</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter32"><span class="item-title-text">Chapter 32</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter33"><span class="item-title-text">Chapter 33</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter34"><span class="item-title-text">Chapter 34</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter35"><span class="item-title-text">Chapter 35</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter36"><span class="item-title-text">Chapter 36</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter37"><span class="item-title-text">Chapter 37</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter38"><span class="item-title-text">Chapter 38</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter39"><span class="item-title-text">Chapter 39</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/part002chapter40"><span class="item-title-text">Chapter40</span></a></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-group toc-item-element-type-part has-no-leading-number has-no-author has-children">
<p class="item-title"><a href="#/upart001"><span class="item-title-text">Part III</span></a></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter41"><span class="item-title-text">Chapter 41</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter42"><span class="item-title-text">Chapter 42</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter43"><span class="item-title-text">Chapter 43</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter44"><span class="item-title-text">Chapter 44</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter45"><span class="item-title-text">Chapter 45</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter46"><span class="item-title-text">Chapter 46</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter47"><span class="item-title-text">Chapter 47</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter48"><span class="item-title-text">Chapter 48</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart001chapter49"><span class="item-title-text">Chapter 49</span></a></p>
</div>
</div>
</div>
<div class="toc-group toc-group-part">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-group toc-item-element-type-part has-no-leading-number has-no-author has-children">
<p class="item-title"><a href="#/upart002"><span class="item-title-text">Part IV</span></a></p>
</div>
<div class="item-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002chapter50"><span class="item-title-text">Chapter 50</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002chapter51"><span class="item-title-text">Chapter 51</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002chapter52"><span class="item-title-text">Chapter 52</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002chapter53"><span class="item-title-text">Chapter 53</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002chapter54"><span class="item-title-text">Chapter 54</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002chapter55"><span class="item-title-text">Chapter 55</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-about-author has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002anotefromthepublisher"><span class="item-title-text">A note from the publisher</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-about-author has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002lovecrimethrillerandmysterybooks"><span class="item-title-text">Love crime, thriller and mystery books?</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/upart002youwillalsoenjoy"><span class="item-title-text">You will also enjoy:</span></a></p>
</div>
</div>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-acknowledgments has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="item-title-text">Acknowledgments</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?08c56f1f